/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { MCQOptionFeedback } from './mCQOptionFeedback';
import type { MCQOptionImageUrl } from './mCQOptionImageUrl';
import type { MCQOptionImageAlt } from './mCQOptionImageAlt';

/**
 * Option for a generated MCQ question.
 */
export interface MCQOption {
  id: string;
  text: string;
  isCorrect: boolean;
  feedback?: MCQOptionFeedback;
  imageUrl?: MCQOptionImageUrl;
  imageAlt?: MCQOptionImageAlt;
}
